<template>
  <div class="message" v-cloak>
    <div  v-if="westore.getters.logined">
      <van-pull-refresh  v-model="is_refresh" @refresh="onRefresh" style="margin-bottom: 50px;">
        <van-list class="article-list-wrap"
                  v-model="is_loading"
                  :finished="is_load_finished"
                  :immediate-check="false"
                  finished-text="没有更多了"
                  :error.sync="is_error"
                  error-text="请求失败，点击重新加载"
                  @load="onLoad">
          <van-cell v-for="(item, index) in list" :key="index" >
            <van-row type="flex" justify="space-around" @click="go_detail(item)">
              <van-col span="3">
                <div class="message-avatar">
                  <van-image  v-if="item.form_user===null" round scale-down lazy-load :src="images.system_head"></van-image>
                  <writer-avatar v-else shape="circle" :size="36" :writer="item.form_user"></writer-avatar>
<!--                  <van-image  v-else round scale-down lazy-load :src="item.form_user.avatar.web_path"></van-image>-->
                </div>
              </van-col>
              <van-col span="20">
                <div class="van-ellipsis weball-font-color-maintext weball-font-14">{{item.msg_title}}</div>
                <div class="weball-font-color-subtext weball-font-14 ">{{item.msg_content}}</div>
                <div class="weball-font-color-subtext weball-font-14">{{item.msg_time}}</div>
              </van-col>
              <van-col span="1">
                <div v-if="item.type==='project'" style="height: 100%;display: flex;flex-direction: column;justify-content: center">
                  <van-icon name="arrow" class="weball-font-color-subtext"></van-icon>
                </div>
              </van-col>
            </van-row>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-else style="margin: 50% 30px">

      <van-button type="info" block @click="go_login">登录</van-button>
      <div style="text-align: center;margin: 30px auto" class="weball-font-color-subtext weball-font-16">登录后查看消息</div>
    </div>
    <van-tabbar   @change=""  route>
      <van-tabbar-item icon="home-o" replace :to="werouter.index.path">首页</van-tabbar-item>
      <van-tabbar-item icon="hot-o" replace :to="werouter.author.path">大神</van-tabbar-item>
      <van-tabbar-item icon="medal-o" replace :to="werouter.match.path">赛事</van-tabbar-item>
      <van-tabbar-item icon="chat-o" replace :to="werouter.message.path">消息</van-tabbar-item>
      <van-tabbar-item icon="user-circle-o" replace :to="werouter.mine.path">我的</van-tabbar-item>
    </van-tabbar>
  </div>

</template>
<script>
    import system_head from '@/assets/system_head.png'
    import WriterAvatar from "@/views/components/WriterAvatar";
    export default {
        name: 'message',
        components:{
          WriterAvatar
        },
        data() {
            return {
                is_msg:false,
                select_value: '',
                images:{
                    system_head:system_head
                },
                page: 0,
                list: [],
                title_list:[],
                is_error: false,
                is_refresh: false,
                is_loading: false,
                is_load_finished: false
            }
        },
        created: function () {
            this.getUserInfo();
            this.eventbus.$on(this.weconfig.event.loginChanged, function (event) {
                this.getUserInfo();
            }.bind(this))
        },
        mounted:function(){

        },
        destroyed:function(){
            this.eventbus.$off(this.weconfig.event.loginChanged);
        },
        methods: {
            go_login:function () {
                this.$router.push({ name:  this.werouter.login.name, query: { redirect_name:  this.werouter.message.name,} })
            },
            getUserInfo:function(){
                let that = this;
                this.westore.dispatch('getUserInfo').then(user => {
                    this.is_msg = user.is_msg===1;
                    this.page = 1;
                    this.getData(this.page, false);
                }).catch((res) => {
                    that.westore.commit('setToken', '')
                })
            },
            onRefresh() {
                if(this.westore.getters.logined){
                    this.page = 1;
                    this.is_load_finished = false;
                    this.getData(this.page, true)
                }
            },
            onLoad() {
                if(this.westore.getters.logined){
                    this.page++;
                    this.getData(this.page, false);
                }
            },
            getData: function (page, refresh) {
                let that = this;
                this.weapi.request({
                    url: 'message_list',
                    method: 'get',
                    params: {page:page},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.$toast('刷新成功！');
                            that.is_refresh = false;
                        }
                        if (that.page <= 1) {
                            that.list = [];
                            that.is_load_finished = false;
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.is_load_finished = true;
                        }
                    }
                    else {
                        that.is_refresh = false;
                        that.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.is_refresh = false;
                    that.is_error = true;
                }).finally(function (response) {
                    that.is_loading = false;
                })
            },
            onInput:function(checked){
                let that = this;
                if(!this.westore.getters.logined){
                    this.$dialog.alert({
                        title:"未登录",
                        message: '请登录后设置消息通知',
                        confirmButtonText:'去登录',
                        showCancelButton:true,
                        cancelButtonText:'取消',
                    }).then(() => {
                        this.$router.push({ name:  this.werouter.login.name, query: { redirect_name:  this.werouter.message.name,} })
                    }).catch(() => {
                    });
                }
                else{
                    this.is_msg  = checked;
                    this.switch_push(this.is_msg)
                }
            },
            switch_push:function(checked){
                let that = this;
                this.weapi.request({
                    url: 'switch_push',
                    method: 'post',
                    params: {is_msg:checked},
                }).then(res => {
                    if (res.data.code === '200') {
                        this.getUserInfo();
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            go_detail: function (item) {
                if(item.type === 'project'){
                    this.$router.push({ name: this.werouter.project.name, params: { project_id: item.data } })
                }
            }
        }
    }
</script>
<style>
  .article-list-wrap{
    background-color: #f4f4f4;

  }
  .message-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .message-avatar{
    padding: 3px 10px 0 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    max-width: 72px;
    max-height: 72px;
  }
</style>
